// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vhvz","colMin":"styles_colMin__wKkLO"};